"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_REQUIRED_STATUS_CODES = exports.ACTIVE_JOB_STATUS_CODES = exports.JobStatus = void 0;
var JobStatus;
(function (JobStatus) {
    JobStatus[JobStatus["Unknown"] = 0] = "Unknown";
    JobStatus[JobStatus["ConsumerServiceRequested"] = 10] = "ConsumerServiceRequested";
    JobStatus[JobStatus["ConsumerServiceCancelled"] = 20] = "ConsumerServiceCancelled";
    JobStatus[JobStatus["ConsumerServiceCancelledTimeout"] = 21] = "ConsumerServiceCancelledTimeout";
    JobStatus[JobStatus["ConsumerServiceCancelledOther"] = 22] = "ConsumerServiceCancelledOther";
    JobStatus[JobStatus["ProviderServiceRejected"] = 30] = "ProviderServiceRejected";
    JobStatus[JobStatus["ProviderServiceAccepted"] = 40] = "ProviderServiceAccepted";
    JobStatus[JobStatus["ProviderScheduleRequested"] = 50] = "ProviderScheduleRequested";
    JobStatus[JobStatus["ConsumerScheduleRejected"] = 60] = "ConsumerScheduleRejected";
    JobStatus[JobStatus["ConsumerScheduleAccepted"] = 70] = "ConsumerScheduleAccepted";
    JobStatus[JobStatus["PmInhouseQueued"] = 74] = "PmInhouseQueued";
    JobStatus[JobStatus["ProviderQueued"] = 75] = "ProviderQueued";
    JobStatus[JobStatus["ProviderEnroute"] = 80] = "ProviderEnroute";
    JobStatus[JobStatus["ProviderOnsite"] = 90] = "ProviderOnsite";
    JobStatus[JobStatus["ProviderTimerRequested"] = 100] = "ProviderTimerRequested";
    JobStatus[JobStatus["ConsumerTimerRejected"] = 110] = "ConsumerTimerRejected";
    JobStatus[JobStatus["ConsumerTimerAccepted"] = 120] = "ConsumerTimerAccepted";
    JobStatus[JobStatus["ProviderPaused"] = 130] = "ProviderPaused";
    JobStatus[JobStatus["ProviderResumeRequested"] = 140] = "ProviderResumeRequested";
    JobStatus[JobStatus["ConsumerResumeRejected"] = 150] = "ConsumerResumeRejected";
    JobStatus[JobStatus["ConsumerResumeAccepted"] = 160] = "ConsumerResumeAccepted";
    JobStatus[JobStatus["ProviderSuspended"] = 169] = "ProviderSuspended";
    JobStatus[JobStatus["ProviderSuspendRequested"] = 170] = "ProviderSuspendRequested";
    JobStatus[JobStatus["ConsumerSuspendRejected"] = 180] = "ConsumerSuspendRejected";
    JobStatus[JobStatus["ConsumerSuspendAccepted"] = 190] = "ConsumerSuspendAccepted";
    JobStatus[JobStatus["ProviderUnsuspendRequested"] = 200] = "ProviderUnsuspendRequested";
    JobStatus[JobStatus["ProviderUnsuspendCancelled"] = 201] = "ProviderUnsuspendCancelled";
    JobStatus[JobStatus["ConsumerUnsuspendRejected"] = 210] = "ConsumerUnsuspendRejected";
    JobStatus[JobStatus["ConsumerUnsuspendAccepted"] = 220] = "ConsumerUnsuspendAccepted";
    JobStatus[JobStatus["ConsumerScheduleRequested"] = 230] = "ConsumerScheduleRequested";
    JobStatus[JobStatus["ProviderScheduleRejected"] = 240] = "ProviderScheduleRejected";
    JobStatus[JobStatus["ProviderScheduleAccepted"] = 250] = "ProviderScheduleAccepted";
    JobStatus[JobStatus["ProviderCompleted"] = 259] = "ProviderCompleted";
    JobStatus[JobStatus["ProviderCompleteRequested"] = 260] = "ProviderCompleteRequested";
    JobStatus[JobStatus["ConsumerCompleteRejected"] = 270] = "ConsumerCompleteRejected";
    JobStatus[JobStatus["ConsumerCompleteAccepted"] = 280] = "ConsumerCompleteAccepted";
    JobStatus[JobStatus["ConsumerEndRequested"] = 290] = "ConsumerEndRequested";
    JobStatus[JobStatus["ProviderEndRejected"] = 300] = "ProviderEndRejected";
    JobStatus[JobStatus["ProviderEndAccepted"] = 310] = "ProviderEndAccepted";
    JobStatus[JobStatus["ProviderMaterialsSubmitted"] = 320] = "ProviderMaterialsSubmitted";
    JobStatus[JobStatus["ProviderFinalizeRequested"] = 330] = "ProviderFinalizeRequested";
    JobStatus[JobStatus["ConsumerFinalizeRejected"] = 340] = "ConsumerFinalizeRejected";
    JobStatus[JobStatus["ConsumerFinalizeAccepted"] = 350] = "ConsumerFinalizeAccepted";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
exports.ACTIVE_JOB_STATUS_CODES = [
    JobStatus.ConsumerServiceRequested,
    JobStatus.ConsumerScheduleAccepted,
    JobStatus.ProviderQueued,
    JobStatus.ProviderEnroute,
    JobStatus.ProviderOnsite,
    JobStatus.ProviderTimerRequested,
    JobStatus.ConsumerTimerRejected,
    JobStatus.ConsumerTimerAccepted,
    JobStatus.ProviderPaused,
    JobStatus.ProviderResumeRequested,
    JobStatus.ConsumerResumeRejected,
    JobStatus.ConsumerResumeAccepted,
    JobStatus.ProviderSuspended,
    JobStatus.ProviderSuspendRequested,
    JobStatus.ConsumerSuspendRejected,
    JobStatus.ConsumerSuspendAccepted,
    JobStatus.ProviderUnsuspendRequested,
    JobStatus.ProviderUnsuspendCancelled,
    JobStatus.ConsumerUnsuspendRejected,
    JobStatus.ConsumerUnsuspendAccepted,
    JobStatus.ConsumerScheduleRequested,
    JobStatus.ProviderScheduleRejected,
    JobStatus.ProviderScheduleAccepted,
    JobStatus.ProviderCompleted,
    JobStatus.ProviderCompleteRequested,
    JobStatus.ConsumerCompleteRejected,
    JobStatus.ConsumerCompleteAccepted,
    JobStatus.ConsumerEndRequested,
    JobStatus.ProviderEndRejected,
    JobStatus.ProviderEndAccepted,
    JobStatus.ProviderMaterialsSubmitted,
    JobStatus.ProviderFinalizeRequested,
    JobStatus.ConsumerFinalizeRejected,
];
exports.ACTION_REQUIRED_STATUS_CODES = [
    JobStatus.ProviderEnroute,
    JobStatus.ProviderOnsite,
    JobStatus.ProviderTimerRequested,
    JobStatus.ConsumerTimerAccepted,
    JobStatus.ProviderPaused,
    JobStatus.ProviderResumeRequested,
    JobStatus.ConsumerResumeAccepted,
    JobStatus.ProviderCompleted,
    JobStatus.ConsumerEndRequested,
    JobStatus.ProviderEndAccepted,
];
